import styled from 'styled-components';

export const FormGrid = styled.div`
  display: inline-grid;
  grid-template-columns: ${(props) => `repeat(${props.cols}, auto);`};
  grid-gap: 10px;
  align-items: center;
  justify-items: stretch;
  place-self: center stretch;
`;

export const ColGrid = styled.div`
  display: grid;
  grid-template-columns: auto;
  grid-gap: 5px;
  align-items: start;
  align-self: start;
`;

export const ModalDiv = styled.div`
  pointer-events: all;
  display: ${(props) => (props.isModalOpen ? 'block' : 'none')};
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 120;
  overflow: auto;
  background-color: rgba(0, 0, 0, 0.5);
`;

export const Overlay = styled.div`
  pointer-events: all;
  position: fixed;
  border-style: solid;
  width: 704px;
  top: 50%;
  left: 50%;
  border-radius: 4px;
  transform: translate(-50%, -50%);
  padding: ${(props) => props.padding || '16px'};
  z-index: 121;
  padding-bottom: 12px;
  background-color: white;
  border-style: hidden;
`;
